import { render, staticRenderFns } from "./SupportTimeTracker.vue?vue&type=template&id=2be704ea&scoped=true&lang=pug&"
import script from "./SupportTimeTracker.vue?vue&type=script&lang=js&"
export * from "./SupportTimeTracker.vue?vue&type=script&lang=js&"
import style0 from "./SupportTimeTracker.vue?vue&type=style&index=0&id=2be704ea&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be704ea",
  null
  
)

/* custom blocks */
import block0 from "./SupportTimeTracker.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports